import { MonoParam } from 'monolang'
import { rpc, Rpc } from 'rpc-mini'

export interface ParamsNodeOptions extends AudioWorkletNodeOptions {
  length: number
}

export interface Param {
  audioParam: AudioParam
  monoParam: MonoParam
}

export class ParamsNode extends AudioWorkletNode {
  static registeredContexts = new Set<BaseAudioContext>()

  static async register(context: BaseAudioContext) {
    if (this.registeredContexts.has(context)) return
    await context.audioWorklet.addModule(
      // @ts-ignore
      new URL('./params-processor.js', import.meta.url).href
    )
    this.registeredContexts.add(context)
  }

  static async create(
    context: BaseAudioContext,
    options: ParamsNodeOptions
  ) {
    await this.register(context)
    return new this(context, options)
  }

  rpc: Rpc
  paramsMap: Map<number, Map<string, Param>> = new Map()

  constructor(
    public context: BaseAudioContext,
    public options: ParamsNodeOptions
  ) {
    super(context, `params-${options.length}`, options)
    this.rpc = rpc(this.port)
  }

  clear() {
    this.rpc('clear')
  }

  async setParams(params: Map<number, MonoParam[] | undefined>) {
    await this.rpc('setParams', params)

    this.paramsMap.clear()

    let index = 0

    params.forEach((monoParams, programIndex) => {
      const idsToAudioParam = new Map<string, Param>()
      this.paramsMap.set(programIndex, idsToAudioParam)

      monoParams?.forEach((monoParam) => {
        const audioParam = this.parameters.get(`p${index++}`)
        if (!audioParam) {
          console.error('Parameter not found for index: ' + (index - 1))
          console.error(monoParam, this)
          return
        }
        idsToAudioParam.set(`${monoParam.id}`, { monoParam, audioParam })
      })
    })
  }
}
